import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CurrentDateTime = () => {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {

   const checkSessionExpiry = () => {
  try {
    const sessionData = localStorage.getItem("userSession");

    if (!sessionData) return;

    const session = JSON.parse(sessionData);

    if (!session?.expiry) return;

    const now = Date.now();
    const expiryTime = new Date(session.expiry).getTime();

    if (now >= expiryTime) {

      alert("Session expired. Please login again.");

      const role = session?.user?.userlevel?.toUpperCase();

      localStorage.clear();

      /* 🔥 ROLE BASED REDIRECT */
      if (role === "SUPERADMIN") {
        navigate("/admin/login", { replace: true });
      } 
      else if (role === "SALESMAN") {
        navigate("/sm/login", { replace: true });
      } 
      else if (role === "DISTRIBUTOR") {
        navigate("/db/login", { replace: true });
      } 
      else {
        navigate("/login", { replace: true });
      }
    }

  } catch (err) {
    console.error("Session check error:", err);

    localStorage.clear();
    navigate("/login", { replace: true });
  }
};

    // ⏱ Run every second
    const interval = setInterval(() => {
      setCurrentDateTime(new Date());
      checkSessionExpiry();
    }, 1000);

    return () => clearInterval(interval);

  }, [navigate]);

  // 📅 Format Date & Time
  const formattedDate = currentDateTime.toLocaleDateString();
  const formattedTime = currentDateTime.toLocaleTimeString();

  return (
    <div style={{ float: 'right', marginLeft: '20px' }}>
      Today's Date: {formattedDate} &nbsp; | &nbsp; Time: {formattedTime}
    </div>
  );
};

export default CurrentDateTime;